import {ReactNode} from "react";

import {IKeyVariable, IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {HomematchPropertyCardDetailMap} from "./HomematchPropertyCardDetailMap";
import {HomematchPropertyCardDetailOfferInfo} from "./HomematchPropertyCardDetailOfferInfo";
import {HomematchPropertyCardDetailOverview} from "./HomematchPropertyCardDetailOverview";

export interface IHomematchPropertyDictionaries {
    facilitiesInfo?: IVariable[];
    parkingPlacesTypes?: IKeyVariable[];
    quarterTypes?: IVariable[];
    standardDescriptions?: IKeyVariable[];
}

interface IProps {
    property: IPropertyDetailDTO;
    dictionaries?: IHomematchPropertyDictionaries;
    disableShowMoreButton?: boolean;
    onShowAll?: () => void;
    onShowMore?: () => void;
    priceHighlightColor?: string;
    /** Map node for the location section; null shows the load-error state, undefined hides the section. */
    map?: ReactNode | null;
}

export const HomematchPropertyCardDetail = (props: IProps) => {
    const {dictionaries, disableShowMoreButton, map, onShowAll, onShowMore, priceHighlightColor, property} = props;

    return (
        <>
            <HomematchPropertyCardDetailOverview priceHighlightColor={priceHighlightColor} property={property} quarterTypes={dictionaries?.quarterTypes} />

            {map !== undefined && <HomematchPropertyCardDetailMap map={map} />}

            <HomematchPropertyCardDetailOfferInfo
                disableShowMoreButton={disableShowMoreButton}
                facilitiesInfo={dictionaries?.facilitiesInfo}
                onShowAll={onShowAll}
                onShowMore={onShowMore}
                parkingPlacesTypes={dictionaries?.parkingPlacesTypes}
                property={property}
                standardDescriptions={dictionaries?.standardDescriptions}
            />
        </>
    );
};
import {ReactNode} from "react";

import {IKeyVariable, IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {HomematchPropertyCardDetailMap} from "./HomematchPropertyCardDetailMap";
import {HomematchPropertyCardDetailOfferInfo} from "./HomematchPropertyCardDetailOfferInfo";
import {HomematchPropertyCardDetailOverview} from "./HomematchPropertyCardDetailOverview";

export interface IHomematchPropertyDictionaries {
    facilitiesInfo?: IVariable[];
    parkingPlacesTypes?: IKeyVariable[];
    quarterTypes?: IVariable[];
    standardDescriptions?: IKeyVariable[];
}

interface IProps {
    property: IPropertyDetailDTO;
    dictionaries?: IHomematchPropertyDictionaries;
    disableShowMoreButton?: boolean;
    onShowAll?: () => void;
    onShowMore?: () => void;
    priceHighlightColor?: string;
    /** Map node for the location section; null shows the load-error state, undefined hides the section. */
    map?: ReactNode | null;
}

export const HomematchPropertyCardDetail = (props: IProps) => {
    const {dictionaries, disableShowMoreButton, map, onShowAll, onShowMore, priceHighlightColor, property} = props;

    return (
        <>
            <HomematchPropertyCardDetailOverview priceHighlightColor={priceHighlightColor} property={property} quarterTypes={dictionaries?.quarterTypes} />

            {map !== undefined && <HomematchPropertyCardDetailMap map={map} />}

            <HomematchPropertyCardDetailOfferInfo
                disableShowMoreButton={disableShowMoreButton}
                facilitiesInfo={dictionaries?.facilitiesInfo}
                onShowAll={onShowAll}
                onShowMore={onShowMore}
                parkingPlacesTypes={dictionaries?.parkingPlacesTypes}
                property={property}
                standardDescriptions={dictionaries?.standardDescriptions}
            />
        </>
    );
};
